import "../site/site.scss";
import React, { useEffect } from "react";
import { HeaderComponent } from "../../components/header-site";
import { FooterComponent } from "../../components/footer-site";
import { PlanSubscriptionSection } from "../../components/plan-subscription-section/PlanSubscriptionSection";
import { FaqSection } from "../../components/faq-section/FaqSection";

export default function PLans() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <React.Fragment>
      <div
        id="plans"
        className="site"
        style={{ flexDirection: "column", display: "flex", flex: 1 }}
      >
        <HeaderComponent />

        <PlanSubscriptionSection />

        <FaqSection />

        <FooterComponent />
      </div>
    </React.Fragment>
  );
}
